import { useSitemapStoreContext } from '../contexts';

import { SORT_OPTIONS, SORT_ORDER, HIDE_OPTIONS, VIEW_OPTIONS } from '../sitemap_lib';

const initializeExpandedKeys = (options) => {
  const { pages, parentKey = '', level = 0, expandedKeys = {}, limit = 2 } = options;

  if (level >= limit) return expandedKeys; // Only expand up to limit level

  pages.forEach((page, index) => {
    const key = parentKey ? `${parentKey}-${index}` : `${index}`;
    expandedKeys[key] = true;
    if (page.children.length > 0) {
      initializeExpandedKeys({ pages: page.children, parentKey: key, level: level + 1, expandedKeys, limit });
    }
  });

  return expandedKeys;
};

export default function SitemapToolbar({ memoisedTree, memoisedSortedPages }) {
  const view = useSitemapStoreContext((state) => state.view);
  const sort = useSitemapStoreContext((state) => state.sort);
  const hide = useSitemapStoreContext((state) => state.hide);
  const pages = useSitemapStoreContext((state) => state.pages);
  const update = useSitemapStoreContext((state) => state.update);

  const { order, key } = sort;

  const handleToggleSortKey = (key) => {
    update({ isLoading: true });

    setTimeout(() => update({ isLoading: false, 'sort.key': key }), 50);
  };

  const handleToggleSortOrder = (order) => {
    update({ isLoading: true });
    setTimeout(() => update({ isLoading: false, 'sort.order': order }), 50);
  };

  const handleToggleHide = (type) => {
    update({ isLoading: true });
    setTimeout(() => update({ isLoading: false, [`hide.${type}`]: !hide[type] }), 50);
  };

  const handleSetExpandedKeys = (mode) => {
    update({ isLoading: true });

    // Use setTimeout to create a small delay
    setTimeout(() => {
      switch (mode) {
        case 'collapse':
          update({ isLoading: false, expandedKeys: {} });
          break;
        case 'expand':
          update({ isLoading: false, expandedKeys: initializeExpandedKeys({ pages, limit: 99 }) });
          break;
        default:
          update({ isLoading: false, expandedKeys: initializeExpandedKeys({ pages }) });
          break;
      }
    }, 50);
  };

  const handleToggleView = () => update({ isLoading: true, view: view === 0 ? 1 : 0 });

  return (
    <div className="d-flex gap-3">
      {view === 1 && (
        <div className="btn-group" role="group">
          <button type="button" className="btn btn-primary dropdown-toggle dp-button-togglers" data-bs-toggle="dropdown" aria-expanded="false">
            Sort
          </button>
          <ul className="dropdown-menu">
            {SORT_OPTIONS.map(({ label, value }) => (
              <li key={value}>
                <button type="button" className={`dropdown-item ${key === value ? 'active' : ''}`} onClick={() => handleToggleSortKey(value)}>
                  {label}
                </button>
              </li>
            ))}
            <li>
              <hr className="dropdown-divider" />
            </li>
            {SORT_ORDER.map(({ label, value }) => (
              <li key={value}>
                <button type="button" className={`dropdown-item ${order === value ? 'active' : ''}`} onClick={() => handleToggleSortOrder(value)}>
                  <span>{label}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="btn-group" role="group">
        <button type="button" className="btn btn-primary dropdown-toggle dp-button-togglers" data-bs-toggle="dropdown" aria-expanded="false">
          View
        </button>
        <ul className="dropdown-menu">
          {Object.entries(HIDE_OPTIONS).map(([key, value]) => (
            <li key={key}>
              <button type="button" className="dropdown-item d-flex align-items-center gap-4" onClick={() => handleToggleHide(key)}>
                {hide[key] ? <i className="fe fe-eye-off" /> : <i className="fe fe-eye" />} {value}
              </button>
            </li>
          ))}
          {view === 0 && (
            <>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <button type="button" className="dropdown-item" onClick={() => handleSetExpandedKeys('collapse')}>
                  Collapse All
                </button>
              </li>
              <li>
                <button type="button" className="dropdown-item" onClick={() => handleSetExpandedKeys('expand')}>
                  Expand All
                </button>
              </li>
              <li>
                <button type="button" className="dropdown-item" onClick={handleSetExpandedKeys}>
                  Expand 2 levels
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
      <button type="button" className="btn btn-primary d-flex gap-2" onClick={handleToggleView}>
        {VIEW_OPTIONS[view].icon} {VIEW_OPTIONS[view].label}
      </button>
    </div>
  );
}
